var map = {
	"./bacon.svg": "cb06",
	"./banana.svg": "43c1",
	"./candy_cane.svg": "c095",
	"./carrot.svg": "6dd8",
	"./cheese.svg": "84ec",
	"./cherries.svg": "e494",
	"./chicken.svg": "757c",
	"./chili.svg": "d3df",
	"./chocolate.svg": "41cc",
	"./donut.svg": "da7e",
	"./fish.svg": "e9ec",
	"./garlic.svg": "95de",
	"./gingerman.svg": "c266",
	"./grain.svg": "0616",
	"./ham.svg": "e40e",
	"./huevo.svg": "b340",
	"./lemon.svg": "cbef",
	"./manzana.svg": "bbdb",
	"./meat.svg": "d9f4",
	"./pineapple.svg": "3d5a",
	"./potato.svg": "e3ec",
	"./watermelon.svg": "e234"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f4a";